export default __webpack_public_path__ + "static/media/information--emergency-facility--g1.5f24e4fe.png";